import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import * as yup from "yup";

import Button from "components/Button";
import Input from "components/Input";
import RadioInput from "components/RadioInput";
import { useRegister } from "providers/Register";
import { PatientRegisterPersonalData } from "types/register";
import { validateBirthDate, validateCpf } from "utils/formValidations";
import {
  handleBirthDateInput,
  handleCpfInput,
  handleMobilePhoneInput,
} from "utils/handleInput";

const PatientPersonalDataForm = () => {
  const navigate = useNavigate();
  const { registerType, setPatientPersonalData } = useRegister();

  const schema = yup.object().shape({
    name: yup.string().required("*Campo obrigatório").uppercase().trim(),
    cpf: yup
      .string()
      .required("*Campo obrigatório")
      .test("cpfValidator", "*CPF inválido", validateCpf)
      .transform((value) => value.replace(/\D/g, "")),
    rg: yup.string().required("*Campo obrigatório").uppercase().trim(),
    sex: yup.string(),
    socialName: yup.string().uppercase().trim(),
    birthDate: yup
      .string()
      .required("*Campo obrigatório")
      .test("birthDateValidator", "*Data inválida", validateBirthDate),
    mobilePhone: yup
      .string()
      .required("*Campo obrigatório")
      .min(15, "*Número de celular inválido"),
  });

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm<PatientRegisterPersonalData>({
    resolver: yupResolver(schema),
  });

  const onSubmit = (data: PatientRegisterPersonalData) => {
    setPatientPersonalData(data);
    navigate(`/cadastro/${registerType}-2`);
  };

  return (
    <form className="p-3 p-sm-4 p-xl-5" onSubmit={handleSubmit(onSubmit)}>
      <div className="form-box p-3 p-sm-4 p-xl-5">
        <header className="row flex-nowrap pt-3 pb-4">
          <div className="col">
            <h5>Dados Pessoais</h5>
          </div>
          <div className="col col-auto text-muted">
            <b className="text-primary">1</b>
            /3
          </div>
        </header>
        <div className="form-group">
          <Input
            className="text-uppercase"
            label="Nome Completo:"
            placeholder="Seu Nome Aqui"
            type="text"
            register={register("name")}
            error={errors?.name?.message}
          />
        </div>

        <div className="row align-items-end">
          <div className="col-md-6">
            <Input
              label="CPF:"
              placeholder="999.999.999-99"
              type="tel"
              maxLength={14}
              register={register("cpf")}
              error={errors?.cpf?.message}
              onChange={(e) => handleCpfInput(e, setValue, "cpf")}
            />
          </div>
          <div className="col-md-6">
            <Input
              className="text-uppercase"
              label="RG:"
              placeholder="9999999-9"
              type="tel"
              register={register("rg")}
              error={errors?.rg?.message}
            />
          </div>
        </div>

        <label className="" htmlFor="select">
          Sexo:
        </label>
        <div className="row">
          <div className="col col-auto">
            <RadioInput
              label="Masculino"
              value="M"
              register={register("sex")}
            />
          </div>
          <div className="col col-auto">
            <RadioInput label="Feminino" value="F" register={register("sex")} />
          </div>
          <div className="col col-auto">
            <RadioInput
              label="Intersexo"
              value="I"
              register={register("sex")}
            />
          </div>
        </div>
        <div className="text-danger mb-3">
          <small>{!!errors?.sex && "*Selecione uma opção"}</small>
        </div>

        <div className="form-group">
          <Input
            className="text-uppercase"
            label="Nome Social:"
            placeholder="Como prefere ser chamado?"
            type="text"
            register={register("socialName")}
            error={errors?.socialName?.message}
          />
        </div>

        <div className="row align-items-end">
          <div className="col-md-6">
            <Input
              label="Data de Nascimento:"
              placeholder="dd/mm/aaaa"
              type="tel"
              maxLength={10}
              register={register("birthDate")}
              error={errors?.birthDate?.message}
              onChange={(e) => handleBirthDateInput(e, setValue, "birthDate")}
            />
          </div>
          <div className="col-md-6">
            <Input
              label="Celular:"
              placeholder="(99) 99999-9999"
              type="tel"
              maxLength={15}
              register={register("mobilePhone")}
              error={errors?.mobilePhone?.message}
              onChange={(e) =>
                handleMobilePhoneInput(e, setValue, "mobilePhone")
              }
            />
          </div>
        </div>
      </div>

      <div className="row no-gutters justify-content-between pt-3 pt-sm-4 pt-xl-5">
        <div className="col col-auto">
          <Button
            className="btn-light"
            type="button"
            onClick={() => navigate(-1)}
          >
            Voltar
          </Button>
        </div>
        <div className="col col-auto">
          <Button className="btn-primary" type="submit">
            Prosseguir
          </Button>
        </div>
      </div>
    </form>
  );
};

export default PatientPersonalDataForm;
